import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../components/ui/Button';
import './NotFound.css';

const NotFound = () => {
  return (
    <div className="not-found-container">
      <div className="not-found-content">
        <h1>404</h1>
        <h2>Page non trouvée</h2>
        <p>La page que vous recherchez n'existe pas ou a été déplacée.</p>
        <div className="not-found-actions">
          <Button type="primary" onClick={() => window.history.back()}>
            Retour
          </Button>
          <Link to="/">
            <Button type="outline">Accueil</Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;